import { render, staticRenderFns } from "./imaged-object-editor.vue?vue&type=template&id=aa3f8f94&scoped=true&"
import script from "./imaged-object-editor.vue?vue&type=script&lang=ts&"
export * from "./imaged-object-editor.vue?vue&type=script&lang=ts&"
import style0 from "./imaged-object-editor.vue?vue&type=style&index=0&id=aa3f8f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3f8f94",
  null
  
)

export default component.exports